if ($('.headline-illustration__apply')[0]) {
    $('.headline-illustration__apply').on('click', function() {
        const link = $(this).attr('data-link');
        console.log('clicked');
        $('html, body').animate(
            {
                scrollTop: $(`.${link}`).offset().top - 100,
            },
            1000
        );
    });
}
